import { Box, Container, Typography, Button, Stack } from "@mui/material";
import { Link } from "react-router-dom";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import VerifiedIcon from "@mui/icons-material/Verified";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

export default function ServicesEnquiryCTA() {
  return (
    <Box sx={{ mt: 10 }}>
      {/* ------------------- CURVED TOP BACKGROUND ------------------- */}
      <Box
        sx={{
          background: "linear-gradient(135deg, #1a237e, #0d1446)",
          borderTopLeftRadius: "80px",
          borderTopRightRadius: "80px",
          pt: 10,
          pb: 8,
          textAlign: "center",
          color: "#fff",
        }}
      >
        <Container>
          {/* ------------------- BADGES ------------------- */}
          <Stack
            direction="row"
            spacing={4}
            justifyContent="center"
            flexWrap="wrap"
            sx={{ mb: 4 }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: "#fff",
              }}
            >
              <FlashOnIcon sx={{ color: "#d50000" }} />
              <Typography sx={{ fontWeight: 600 }}>Fast Service</Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: "#fff",
              }}
            >
              <VerifiedIcon sx={{ color: "#4cafef" }} />
              <Typography sx={{ fontWeight: 600 }}>
                Certified Experts
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                color: "#fff",
              }}
            >
              <AccessTimeIcon sx={{ color: "#d50000" }} />
              <Typography sx={{ fontWeight: 600 }}>24/7 Support</Typography>
            </Box>
          </Stack>

          {/* ------------------- TITLE ------------------- */}
          <Typography
            variant="h4"
            fontWeight={800}
            sx={{
              mb: 2,
              fontSize: { xs: "2rem", md: "2.6rem" },
              color: "#fff",
            }}
          >
            Need Professional Service Support?
          </Typography>

          {/* ------------------- SUBTEXT ------------------- */}
          <Typography
            sx={{
              mb: 4,
              color: "rgba(255,255,255,0.8)",
              maxWidth: 720,
              mx: "auto",
              fontSize: { xs: "0.98rem", md: "1.1rem" },
              lineHeight: 1.6,
            }}
          >
            Our expert team delivers fabrication, installation, maintenance, and
            custom engineering solutions — tailored specifically for your
            project needs.
          </Typography>

          {/* ------------------- BUTTON ------------------- */}
          <Button
            component={Link}
            to="/contact"
            sx={{
              px: 4,
              py: 1.4,
              fontSize: "1.1rem",
              borderRadius: 2,
              background: "#d50000",
              color: "#fff",
              "&:hover": { background: "#b30000",color: "#fff" },
              boxShadow: "0 6px 18px rgba(0,0,0,0.2)",
              width: { xs: "100%", sm: "auto" },
            }}
          >
            Request Service Now
          </Button>
        </Container>
      </Box>
    </Box>
  );
}
